import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  stepperActiveIndex: 0,
  openLocationModal: false,
  stateList: [],
  coupon: null,
  bookingID: null,
  isDiscountModalOpen: false
};

export const StateSlice = createSlice({
  name: 'StateSlice',
  initialState,

  reducers: {
    setStepperActiveIndex: (state, action) => {
      state.stepperActiveIndex = action.payload;
    },
    setOpenLocationModal: (state, action) => {
      state.openLocationModal = action.payload;
    },
    setStateList: (state, action) => {
      state.stateList = action.payload;
    },
    setCouponDetails: (state, action) => {
      state.coupon = action.payload;
    },
    setIsDiscountModalOpen: (state, action) => {
      state.isDiscountModalOpen = action.payload;
    }
  }
});

export const {
  setStepperActiveIndex,
  setOpenLocationModal,
  setStateList,
  fetchData,
  setIsDiscountModalOpen,
  setCouponDetails
} = StateSlice.actions;
export default StateSlice.reducer;
